<template>
  <MainLayout page-name="flight-data">
    <PageHeader :title="title">
      <el-row class="header-button">
        <el-col>
          <el-button type="primary" class="import" @click="clickImport">新規取込</el-button>
        </el-col>
        <el-col>
          <el-button type="primary" class="detail-search" @click="clickDetailSearch">詳細検索</el-button>
        </el-col>
      </el-row>
      <SimpleSearch
        :model="simpleSearchFormModel"
        @search="clickSearch"
      >
        <BillingYm v-model="simpleSearchFormModel.billing_ym" :searchCond="true" :initialize="true" mode="search" :required="true"/>
        <ActionType v-model="simpleSearchFormModel.action_type" :searchCond="true" :initialize="true" mode="flightAction" />
        <RouteCode v-model="simpleSearchFormModel.route_code" :searchCond="true" :initialize="true" placeholder="線別" label=""/>
        <CustomerCode v-model="simpleSearchFormModel.operator_code" :searchCond="true" :initialize="true" label="運航者" prop="operator_code" :autocomplete-list="customerCodeSet" />
        <RegistrationSymbol v-model="simpleSearchFormModel.registration_symbol" :searchCond="true" :autocomplete-list="registrationSymbolSet" initialize="true" />
        <FlightPurposeCode v-model="simpleSearchFormModel.flight_purpose_code" :searchCond="true" :initialize="true" mode="search" placeholder="飛行目的" label="" />
      </SimpleSearch>
    </PageHeader>
    <Table
      :multiSelect="false"
      :table-data="tableData"
      :dataFormatter="csvDataFormatter"
      :default-sort="{ prop: 'actual_time_departure', order: 'ascending' }"
      @row-click="clickRow"
      @multiple-delete="deleteRows"
    >
      <template #columns>
        <!-- <ActionTypeNameColumn :sortable="true" label="着離陸区分" />
        <CallsignColumn :sortable="true" />
        <RouteCodeColumn :sortable="true" />
        <CustomerCodeColumn :sortable="true" label="運航者" prop="operator_code" />
        <RegistrationSymbolColumn :sortable="true" />
        <FlightPurposeCodeColumn :sortable="true" label="飛行目的" />
        <AirportCodeColumn :sortable="true" label="出発地" prop="departure_airport_code" />
        <AirportCodeColumn :sortable="true" label="目的地" prop="destination_airport_code" />
        <DateTimeColumn :sortable="true" label="ATD" prop="actual_time_departure" />
        <DateTimeColumn :sortable="true" label="ATA" prop="actual_time_arrival" /> -->
        <ActionTypeNameColumn label="着離陸区分" />
        <CallsignColumn />
        <RouteCodeColumn />
        <CustomerCodeColumn label="運航者" prop="operator_code" />
        <RegistrationSymbolColumn />
        <FlightPurposeCodeColumn label="飛行目的" />
        <AirportCodeColumn label="出発地" prop="departure_airport_code" />
        <AirportCodeColumn label="目的地" prop="destination_airport_code" />
        <DateTimeColumn label="ATD" prop="actual_time_departure" />
        <DateTimeColumn label="ATA" prop="actual_time_arrival" />
      </template>
    </Table>
    <FlightDataImportDialog
      :visible.sync="importDialogVisible"
      @refresh="refreshSearch"
    />
    <FlightDataDetailSearchDialog
      :visible.sync="detailDalogVisible"
      :autocomplete-registration-symbol-set="registrationSymbolSet"
      :autocomplete-model-code-set="modelCodeSet"
      :autocomplete-customer-code-set="customerCodeSet"
      :autocomplete-airport-code-set="airportCodeSet"
      @search="detailSearch"
    />
    <FlightDataEditDialog
      :visible.sync="editDialogVisible"
      :autocomplete-registration-symbol-set="registrationSymbolSet"
      :autocomplete-model-code-set="modelCodeSet"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />

  </MainLayout>
</template>

<script>
import MainLayout from '@/components/templates/MainLayout.vue'
import PageHeader from '@/components/organisms/PageHeader.vue'
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import ActionType from '@/components/molecules/form/select/ActionType'
import RouteCode from '@/components/molecules/form/select/RouteCode.vue'
import CustomerCode from '@/components/molecules/form/autocomplete/CustomerCode.vue'
import RegistrationSymbol from '@/components/molecules/form/autocomplete/RegistrationSymbol.vue'
import FlightPurposeCode from '@/components/molecules/form/select/FlightPurposeCode.vue'
import SimpleSearch from '@/components/organisms/SimpleSearch.vue'
// import Table from '@/components/molecules/table/Table.vue'
import Table from '@/components/molecules/table/TablePaging.vue'
import ActionTypeNameColumn from '@/components/molecules/table/ActionTypeNameColumn.vue'
import CallsignColumn from '@/components/molecules/table/CallsignColumn.vue'
import RouteCodeColumn from '@/components/molecules/table/RouteCodeColumn.vue'
import CustomerCodeColumn from '@/components/molecules/table/CustomerCodeColumn.vue'
import RegistrationSymbolColumn from '@/components/molecules/table/RegistrationSymbolColumn.vue'
import FlightPurposeCodeColumn from '@/components/molecules/table/FlightPurposeCodeColumn.vue'
import AirportCodeColumn from '@/components/molecules/table/AirportCodeColumn.vue'
import DateTimeColumn from '@/components/molecules/table/DateTimeColumn.vue'
import FlightDataImportDialog
  from '@/components/pages/data/flightData/FlightDataImportDialog.vue'
import FlightDataDetailSearchDialog
  from '@/components/pages/data/flightData/FlightDataDetailSearchDialog.vue'
import FlightDataEditDialog
  from '@/components/pages/data/flightData/FlightDataEditDialog.vue'
import CustomerAutocompleteLoader from '@/mixins/CustomerAutocompleteLoader.vue'
import RegistrationSymbolAutocompleteLoader from '@/mixins/RegistrationSymbolAutocompleteLoader.vue'
import AirportAutocompleteLoader from '@/mixins/AirportAutocompleteLoader.vue'

export default {
  components: {
    MainLayout,
    PageHeader,
    BillingYm,
    ActionType,
    RouteCode,
    CustomerCode,
    RegistrationSymbol,
    FlightPurposeCode,
    SimpleSearch,
    Table,
    ActionTypeNameColumn,
    CallsignColumn,
    RouteCodeColumn,
    CustomerCodeColumn,
    RegistrationSymbolColumn,
    FlightPurposeCodeColumn,
    DateTimeColumn,
    AirportCodeColumn,
    FlightDataImportDialog,
    FlightDataDetailSearchDialog,
    FlightDataEditDialog
  },
  mixins: [
    RegistrationSymbolAutocompleteLoader,
    CustomerAutocompleteLoader,
    AirportAutocompleteLoader
  ],
  data () {
    return {
      title: '運航データ',
      tableData: [],
      simpleSearchFormModel: {
        billing_ym: this.getDefaultBillingYm(),
        action_type: '',
        route_code: '',
        operator_code: '',
        registration_symbol: '',
        flight_purpose_code: ''
      },
      currentRow: {},
      importDialogVisible: false,
      registerDialogVisible: false,
      detailDalogVisible: false,
      editDialogVisible: false
    }
  },
  computed: {
  },
  mounted () {
    sessionStorage.removeItem('flightDataSearchCond')
    this.loadRegistrationSymbol()
    this.loadCustomer()
    this.loadAirport()
  },
  methods: {
    clickImport () {
      this.importDialogVisible = true
    },
    clickRegister () {
      this.currentRow = {}
      this.registerDialogVisible = true
    },
    clickDetailSearch () {
      this.detailDalogVisible = true
    },
    clickSearch () {
      sessionStorage.setItem('flightDataSearchCond', JSON.stringify(this.simpleSearchFormModel))
      this.search()
    },
    detailSearch () {
      const searchCond = JSON.parse(sessionStorage.getItem('flightDataSearchCond'))
      Object.keys(this.simpleSearchFormModel).forEach((x) => { this.$set(this.simpleSearchFormModel, x, searchCond[x]) })
      this.search()
    },
    search () {
      this.$loadingMask.on()
      const searchCond = JSON.parse(sessionStorage.getItem('flightDataSearchCond'))
      this.$axios
        .get('/search-flight-data', { params: searchCond })
        .then((res) => {
          this.tableData = res.data.list
          for (var i = 0; i <= this.tableData.length - 1; i += 1) {
            // this.tableData[i].selected = false
            this.$set(this.tableData[i], 'selected', false)
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    refreshSearch (billingYm) {
      const searchCond = JSON.parse(sessionStorage.getItem('flightDataSearchCond'))
      if (!searchCond) {
        this.$set(this.simpleSearchFormModel, 'billing_ym', billingYm)
        sessionStorage.setItem('flightDataSearchCond', JSON.stringify(this.simpleSearchFormModel))
      }

      this.search()
    },
    csvDataFormatter (row) {
      const result = { ...row }
      delete result.update_on
      result.start_date += ' 00:00:00'
      result.end_date += ' 00:00:00'
      return result
    },
    // clickRow (row, column, event) {
    //   this.currentRow = row
    //   this.editDialogVisible = true
    // },
    clickRow (row, table) {
      this.currentRow = row
      this.editDialogVisible = true
      this.tableData = table
    },
    copyRow (row) {
      this.currentRow = row
      this.registerDialogVisible = true
    },
    deleteRow (row) {
      this.deleteRows([row])
    },
    async deleteRows (rows) {
      if (!(await this.messageBox(this.title, 'MG0001W', '削除'))) {
        return
      }

      this.$loadingMask.on()
      await this.$axios
        .delete('/flight-data', { data: rows })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.search()
        })
        .catch((e) => {
          this.$loadingMask.off()
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message, true)
                break
              default:
            }
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 2rem;
  ::v-deep .el-col {
    width: auto;
    margin-left: 2rem;
    .el-button {
      font-size: inherit;
      width: 20rem;
    }
  }
}
.route-code {
  ::v-deep .el-form-item__content {
    width: 6.5em;
  }
}
.dummy {
  display: none;
}
</style>
